import $ from 'jquery';

$('.js-readmore').each(function () {
	let defaultHeight = $('.js-readmore-content', this).outerHeight();
	let text = $('.js-readmore-content', this);
	let textHeight = text[0].scrollHeight;
	let button = $('.js-readmore-btn', this);

	if (textHeight < 32) {
		button.hide();
	} else {
		button.show();
	}

	if ($(this).hasClass('c-imgtext1__info')) {
		if (textHeight <= 240) {
			button.hide();
		} else {
			button.show();
		}
	}

	if ($(this).hasClass('c-detail__box2')) {
		if (textHeight <= 132) {
			button.hide();
		} else {
			button.show();
		}
	}

	button.on('click', function () {
		var newHeight = 0;
		if ($(this).hasClass('is-open')) {
			newHeight = defaultHeight;
			$(this).removeClass('is-open');
			$(this).find('span').text('続きを読む');
		} else {
			newHeight = textHeight;
			$(this).addClass('is-open');
			$(this).find('span').text('閉じる');
		}
		text.animate(
			{
				'max-height': newHeight,
			},
			500,
		);
	});
});
